export default "__VITE_ASSET__P8dSNN_w__"